import { func } from 'prop-types';
import queryString from 'query-string';
import React, { Suspense, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Switch } from 'react-router-dom';
import styled from 'styled-components';

import { get } from 'ravenjs/utils/lodash';
import Container from 'ravenjs/lib/Container';

import AppNavigationLogoBar from 'components/AppNavigationLogoBar';
import { HISTORY } from 'constants/proptypes';
import { actions as brandingActions } from 'modules/branding';
import Route from 'routes/Route';
import AssessmentTool from './AssessmentTool';
import AssessmentToolInvalid from './AssessmentToolInvalid';
import AssessmentToolSuccess from './AssessmentToolSuccess';

const ContainerStyled = styled(Container)`
    position: relative;
`;

const Prospect = props => {
    const { fetchBranding } = props;
    const [logoUrl, setLogoUrl] = useState(null);
    const [isBrandingFetched, setBrandingFetchedStatus] = useState(false);
    const getDefaultBranding = useCallback(async () => {
        const domain = MAESTER.companies.root_company_id;
        return fetchBranding(domain);
    }, [fetchBranding]);

    const getBranding = useCallback(async () => {
        let branding;

        try {
            const queryParams = get(props.history.location, 'search', '');
            const queryParamsParse = queryString.parse(queryParams);
            const partnerId = get(queryParamsParse, 'partnerId', null);

            branding = partnerId ? await fetchBranding(partnerId) : await getDefaultBranding();
        } catch (e) {
            branding = await getDefaultBranding();
        } finally {
            setBrandingFetchedStatus(true);
        }
        const brandingLogoUrl = get(branding, 'config.logoUrl', null);
        setLogoUrl(brandingLogoUrl);
    }, [fetchBranding, getDefaultBranding, props.history.location]);

    useEffect(() => {
        if (!isBrandingFetched) {
            getBranding();
        }
    }, [getBranding, isBrandingFetched]);

    if (logoUrl) {
        return (
            <>
                <AppNavigationLogoBar logoUrl={logoUrl} />
                <ContainerStyled>
                    <Suspense fallback={<div />}>
                        <Switch>
                            <Route
                                isPublic
                                path="/public/prospect/assessment-tool"
                                render={props => <AssessmentTool {...props} />}
                            />
                            <Route
                                isPublic
                                path="/public/prospect/assessment-tool-invalid"
                                render={props => <AssessmentToolInvalid {...props} />}
                            />
                            <Route
                                isPublic
                                path="/public/prospect/assessment-tool-success"
                                render={props => <AssessmentToolSuccess {...props} />}
                            />
                        </Switch>
                    </Suspense>
                </ContainerStyled>
            </>
        );
    }

    return null;
};

Prospect.propTypes = {
    fetchBranding: func.isRequired,
    history: HISTORY.isRequired,
};

const mapDispatchToProps = {
    fetchBranding: brandingActions.fetchBranding,
};

export { Prospect as ProspectUnwrapped };
export default connect(null, mapDispatchToProps)(Prospect);
